/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Input, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ReadOnlyTextFieldView } from '../ReadOnlyTextField.view';
import appIds from '../../../constants/export_apps.json';
interface Props {
	newsSourcesAppId: string;
	isReadOnlyField?: boolean;
	newsSourcesAppIDChange: (newAppId: string) => void;
}

class NewsSourcesChooseAppID extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
		this.handleNewsSourcesAppIDChange = this.handleNewsSourcesAppIDChange.bind(this);
	}

	handleNewsSourcesAppIDChange(event: SelectChangeEvent<string>): void {
		const value = `${event.target.value || ''}`;
		const { newsSourcesAppIDChange } = this.props;
		newsSourcesAppIDChange && newsSourcesAppIDChange(value);
	}

	render(): JSX.Element {
		const { newsSourcesAppId, isReadOnlyField } = this.props;
		return isReadOnlyField ? (
			<ReadOnlyTextFieldView
				id="AppID"
				name="AppID"
				label="AppID"
				value={newsSourcesAppId}
				InputLabelProps={{ shrink: true }}
				InputProps={{ readOnly: true }}
				fullWidth
			/>
		) : (
			<>
				<InputLabel htmlFor="AppID">App auswählen</InputLabel>
				<Select
					variant="standard"
					name="AppID"
					value={newsSourcesAppId}
					onChange={this.handleNewsSourcesAppIDChange}
					input={<Input id="AppID" />}
					fullWidth
				>
					{appIds.map(app => {
						return (
							<MenuItem key={app.id} value={app.id}>
								{app.name}
							</MenuItem>
						);
					})}
				</Select>
			</>
		);
	}
}

export default NewsSourcesChooseAppID;
